import { render, staticRenderFns } from "./SlideWrapperForSharingView.vue?vue&type=template&id=42ed4c6b&scoped=true&"
import script from "./SlideWrapperForSharingView.vue?vue&type=script&lang=js&"
export * from "./SlideWrapperForSharingView.vue?vue&type=script&lang=js&"
import style0 from "./SlideWrapperForSharingView.vue?vue&type=style&index=0&id=42ed4c6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed4c6b",
  null
  
)

export default component.exports